/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ContentTaskPlanIterator from '../content-task-plan-iterator';

/**
 * @private
 * @typedef {Record<string, *>} IcalApi TODO #555
 * @typedef {import('../../../content-task').ContentTask} ContentTask
 */

/**
 * Továrna na iterátory plánu obsahových úloh
 */
class ContentTaskPlanIteratorFactory {
  /**
   * Vytvoří instanci.
   * @param {IcalApi} ICAL
   * @param {number} maxInterval Maximální délka intervalu,
   * ve kterém se vyhledávají události. [s]
   */
  constructor(ICAL, maxInterval) {
    this.ICAL = ICAL;
    this.maxInterval = maxInterval;
  }

  /**
   * Vytvoří nový iterátor.
   * @param {Date} atDate Okamžik, od kterého se má začít vytvářet plán.
   * @param {ContentTask[]} contentTasks Obsahové úlohy, pro které se vytvoří plán.
   * Pořadí úloh je od nejdůležitější po nejméně důležitou.
   * @returns {ContentTaskPlanIterator}
   */
  create(atDate, contentTasks) {
    return new ContentTaskPlanIterator(
      this.ICAL,
      atDate,
      contentTasks,
      this.maxInterval
    );
  }
}

export default ContentTaskPlanIteratorFactory;
